(function () {
  'use strict';

  const STORAGE_KEY = 'duckyboo:recently-viewed';
  const MAX_STORED = 20;

  function getStoredProducts() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveProducts(products) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (e) {
      // localStorage full or unavailable
    }
  }

  function trackProduct() {
    const el = document.querySelector('[data-recently-viewed-product]');
    if (!el) return;

    let data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }

    if (!data || !data.handle) return;

    const products = getStoredProducts();
    const filtered = products.filter(function (p) {
      return p.handle !== data.handle;
    });

    filtered.unshift({
      handle: data.handle,
      title: data.title,
      url: data.url,
      price: data.price,
      compareAtPrice: data.compareAtPrice,
      imageUrl: data.imageUrl,
      imageAlt: data.imageAlt,
      timestamp: Date.now()
    });

    saveProducts(filtered.slice(0, MAX_STORED));
  }

  function getProducts(limit) {
    var products = getStoredProducts();
    var currentHandle = getCurrentProductHandle();
    if (currentHandle) {
      products = products.filter(function (p) {
        return p.handle !== currentHandle;
      });
    }
    return products.slice(0, limit || 4);
  }

  function getCurrentProductHandle() {
    var el = document.querySelector('[data-recently-viewed-product]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).handle;
    } catch (e) {
      return null;
    }
  }

  function formatPrice(cents) {
    if (cents == null) return '';
    var amount = (cents / 100).toFixed(2);
    // Remove trailing zeros for whole numbers
    amount = amount.replace(/\.00$/, '');
    return amount + ' TL';
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function renderCards(container, limit) {
    if (!container) return;
    var products = getProducts(limit);
    if (!products.length) {
      container.closest('.search-empty-state__recently-viewed').style.display = 'none';
      return;
    }

    container.closest('.search-empty-state__recently-viewed').style.display = '';
    var html = '';

    products.forEach(function (product) {
      var compareHtml = '';
      if (product.compareAtPrice && product.compareAtPrice > product.price) {
        compareHtml = '<s class="search-empty-state__product-compare-price">' + formatPrice(product.compareAtPrice) + '</s> ';
      }

      html += '<a href="' + escapeHtml(product.url) + '" class="search-empty-state__product-card">' +
        '<div class="search-empty-state__product-image-wrap">' +
          '<img src="' + escapeHtml(product.imageUrl) + '" ' +
               'alt="' + escapeHtml(product.imageAlt) + '" ' +
               'class="search-empty-state__product-image" ' +
               'loading="lazy" width="360" height="360">' +
        '</div>' +
        '<div class="search-empty-state__product-title">' + escapeHtml(product.title) + '</div>' +
        '<div class="search-empty-state__product-price">' + compareHtml + formatPrice(product.price) + '</div>' +
      '</a>';
    });

    container.innerHTML = html;
  }

  // Track on product pages
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackProduct);
  } else {
    trackProduct();
  }

  // Expose API
  window.DuckybooRecentlyViewed = {
    getProducts: getProducts,
    renderCards: renderCards
  };
})();
